import type React from 'react';

export function IconButton({
  onClick, title, children,
}: { onClick: () => void; title: string; children: React.ReactNode }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      className="flex items-center justify-center rounded-md max-sm:min-h-[40px] max-sm:min-w-[40px]"
      style={{ width: 30, height: 30, color: 'var(--ink-2)', background: 'transparent' }}
      onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--ivory-2)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
    >
      {children}
    </button>
  );
}

export function Dropdown({
  children, width = 240, align = 'left', padding = 4,
}: {
  children: React.ReactNode; width?: number; align?: 'left' | 'right'; padding?: number;
}) {
  return (
    <div
      className="absolute rounded-lg border shadow-lg"
      style={{
        top: '100%',
        [align]: 0,
        marginTop: 4,
        width,
        padding,
        background: 'var(--ivory-1)',
        borderColor: 'var(--line)',
        boxShadow: 'var(--sh-3)',
        zIndex: 50,
      } as React.CSSProperties}
    >
      {children}
    </div>
  );
}

export function DropdownLabel({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="px-2.5 py-1.5 text-[10px] font-semibold uppercase tracking-wider"
      style={{ color: 'var(--ink-3)' }}
    >
      {children}
    </div>
  );
}

export function DropdownItem({
  onClick, children, danger = false,
}: { onClick?: () => void; children: React.ReactNode; danger?: boolean }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center gap-2 rounded-md px-2.5 py-1.5 text-left text-[13px]"
      style={{
        color: danger ? 'var(--danger)' : 'var(--ink-1)',
        background: 'transparent',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--ivory-2)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
    >
      {children}
    </button>
  );
}

export function DropdownDivider() {
  return <div className="my-1 h-px" style={{ background: 'var(--line)' }} />;
}

